import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

type Props = {
  label: string | undefined
  value: string | undefined
  className?: string
}

const LabelValuePair = ({ label, value, className }: Props) => {
  return (
    <div className={className} >
      <S.Label>{label}</S.Label>
      <S.Value>{value}</S.Value>
    </div>
  )
}

export default LabelValuePair

const S = {
  Label: styled.div`
    font-size: 10px;
    color: ${color('premiumText')};
  `,
  Value: styled.div`
    font-size: 16px;
    color: ${color('premiumText')};
  `
}
